<template>
  <div class="c-table"
       ref="table"
       :class="{
      // 'c-table_scrolled': isScrolled,
      'c-table_scroll_end': isScrollEnd,
      'c-table_scroll': isScroll,
    }"
  >

    <m-column-filters
      :column="filteredColumn"
      :referenceList="referenceList"
      :activeFilters="activeFilteredColumns"
      v-on:getReferenceValues="getReferenceValues"
      @close="filteredColumn = null"
      @setFilter="setColumnFilter"
      @removeFilter="removeColumnFilter"
      ref="columnFilters"
    />

    <div v-if="data.records.length !== 0"
         :class="{
            'c-table__shadow': data.actions,
            'c-table__shadow_active': data.actions,
            // 'c-table__empty__shadow': data.records.length === 0
         }"></div>
    <div class="c-table__scrollbar-wrapper" v-if="isScroll"></div>

    <perfect-scrollbar class="c-table__wrapper" ref="wrapper" @scroll="scroll">
      <table id="tableWithFixedFirstColumn" class="c-table__container" ref="container">
        <thead class="c-table__header" ref="header">
        <tr class="c-table__header-row" v-for="i in levels" :key="i">
          <th class="c-table__column"
              v-for="column in getTableColumns(i)"
              :key="column.id"
              :colspan="getColspan(column)"
              :rowspan="getRowspan(column)"
              :id="`c-table-column-${column.id}`"
              v-if="isLatenessShow(column)"
              :class="{
                'c-table__column_with_filter': column.type,
                'c-table__column_border_left': (data.type === 'new-calculation-lateness' && column.id === getFirstInTotalChildColumn()),
                'c-table__column_hidden': isDisabled(column.id),
                'c-table__column_sorted': isSorted(column),
              }"
          >
            <div class="c-table__column-wrapper">
              <div class="c-table__column-label"
                   :class="{ 'c-table__column-label-children': !isCategory(column) && sortedColumn }"
                   @click="setSortedColumn(column, sortedColumn)">{{ column.label }}</div>

              <div class="c-table__column-actions"
                   v-if="(column.description || column.type) && data.type !== 'new-calculation-lateness'"
              >
                <div class="c-table__column-action c-table__column-action_description" v-if="column.fullName">
                  <c-button
                    size="small"
                    icon="info"
                    :id="`table-column-button-description-${column.id}`"
                    noBorder
                  />

                  <b-popover placement="top" triggers="hover" :target="`table-column-button-description-${column.id}`">
                    {{ column.fullName }}
                  </b-popover>
                </div>

                <div class="c-table__column-action" v-if="isColumnFiltered(column.id)">
                  <c-button
                    size="small"
                    noBorder
                    :id="`table-column-button-filter-${column.id}`"
                    :active="isColumnActiveFiltered(column.id)"
                    @click="openColumnFilterModal(column)"
                    :icon="{
                        icon: 'filter-column',
                        activeColor: 'blue'
                      }"
                  />

                  <b-popover placement="top" triggers="hover"
                             :target="`table-column-button-filter-${column.id}`">
                    {{ isColumnActiveFiltered(column.id) ? 'Изменить фильтр' : 'Применить фильтр' }}
                  </b-popover>
                </div>
              </div>
            </div>
          </th>

          <th class="c-table__column c-table__column_actions"
              :rowspan="levels"
              v-if="data.actions && i === 1">
            <div class="c-table__column-empty"></div>
          </th>
        </tr>
        </thead>

        <tbody class="c-table__records">
        <tr class="c-table__record"
            v-for="(record, recordIndex) in data.records"
            :key="recordIndex" v-show="record.isShowRow"
        >

          <td v-if="data.type === 'new-calculation-lateness'"
              class="c-table__cell_total c-table__cell c-table__cell_number"
              :class="{
                'c-table__cell__grey': isGreyCell(data.type, 'total', record.isTotalRow),
              }"
          >
            <div class="c-table__cell-value">{{ record['total'].value }}</div>
          </td>

          <td class="c-table__cell"
              v-for="column in getTableColumns(levels)"
              v-if="isLatenessShow(column)"
              :key="column.id"
              :style="{'background': getLatenessColor(column.id, record.isTotalRow, record[column.id].value)}"
              :class="{
                'c-table__cell__yellow': isYellowCell(data.type, column.id, record[column.id].value, record.isTotalRow),
                'c-table__cell__red': isRedCell(data.type, column.id, record[column.id].value, record.isTotalRow),
                'c-table__cell__green': isGreenCell(data.type, column.id, record[column.id].value, record.isTotalRow),
                'c-table__cell__grey': isGreyCell(data.type, column.id, record.isTotalRow, record.isTotalRow),
                'c-table__cell_border_left': (data.type === 'new-calculation-lateness' && column.id === getFirstInTotalChildColumn()),
                'c-table__cell_string': column.type === 'string',
                'c-table__cell_reference': column.type === 'reference',
                'c-table__cell_number': column.type === 'number',
                'c-table__cell_date': column.type === 'date',
                'c-table__cell_hidden': isDisabled(column.id),
                ['c-table__cell_' + column.id]: column.id
              }"
          >
            <c-table-lateness-cell
              v-if="isLatenessCell(column.id, record.isTotalRow)"
              :record="record"
              :column-id="column.id"
              :column-label="column.label"
              :parent-column-id="column.parentColumnId"
              :calculation-data="calcData"
              :can-edit="canEdit"
            />
            <div v-else
                 class="c-table__cell-value"
                 :style="{ 'text-align': (data.type === 'new-calculation-lateness' && column.id !== 'load_sushiChef' && column.id !== 'load_hotShop') ? 'center' : 'right'}"
                 :class="{'c-table__cell-value__grey': data.type === 'new-calculation-lateness' && isTotalValuesLateness(column.id)}"
            >{{ record[column.id].value }}</div>
          </td>

          <td class="c-table__cell c-table__cell_actions" v-if="data.actions">
            <div class="c-table__cell-actions">
              <c-table-actions :type="data.type" v-if="data.type === 'employees'"
                               :record="record" :recordIndex="recordIndex" :recordCount="data.records.length"
              />
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </perfect-scrollbar>

    <div v-if="data.records.length === 0" class="c-table__empty__records">{{ emptyRecordsLabel }}</div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

import Button from '@/components/controls/button'
import DataTableCell from '@/components/data-table/cell'
import DataTableActions from '@/components/data-table/actions'
import ColumnFiltersModal from '@/components/modals/column-filters'
import LatenessCell from '@/pages/calculations/create/additions/lateness-cell-lateness'

export default {
  name: 'data-table-create-calculations-tabs',

  props: [
    'levels',
    'maxWidth',
    'data',
    'enabledFields',
    'disabledColumns',
    'sortedColumn',
    'filteredColumns',
    'activeFilteredColumns',
    'referenceList',
    'emptyRecordsLabel',
    'calcData',
    'canEdit',
  ],



  components: {
    'c-button': Button,
    'c-table-cell': DataTableCell,
    'c-table-actions': DataTableActions,
    'm-column-filters': ColumnFiltersModal,
    'c-table-lateness-cell': LatenessCell
  },

  computed: {
    ...mapGetters('app', [
      'sidebarCollapsed'
    ]),

    // sortedRecords: function() {
    //   if (!this.sortedColumn) {
    //     return this.data.records
    //   }
    //
    //   let sortedColumn = this.sortedColumn.sortBy
    //   let sortType = (this.sortedColumn.sortType === 'asc') ? 1 : -1
    //   let sortedColumns
    //
    //   if (sortedColumn === 'created') {
    //     sortedColumns = this.data.records.sort(function(a, b) {
    //       let dateA = moment(a[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       let dateB = moment(b[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       if (isNaN(dateA) || isNaN(dateB)) {
    //         return 0
    //       }
    //       if (sortType === -1) {
    //         return (dateB > dateA) ? 1 : (dateA > dateB) ? -1 : 0;
    //       } else if (sortType === 1) {
    //         return (dateA > dateB) ? 1 : (dateB > dateA) ? -1 : 0;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   } else {
    //     sortedColumns = this.data.records.sort(function (a, b) {
    //       if (a[sortedColumn].value.toLowerCase() < b[sortedColumn].value.toLowerCase()) {
    //         return -1 * sortType;
    //       } else if (a[sortedColumn].value > b[sortedColumn].value) {
    //         return 1 * sortType;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   }
    //
    //   return sortedColumns
    // }
  },

  mounted () {
    this.updatePositionTop();

    window.addEventListener("touchend", this.handleTouchMove, {
      passive: false
    });
    document.querySelector('.layout').addEventListener('scroll', this.handleLayoutScroll);
    document.querySelector('.ps').addEventListener('scroll', this.handleTableScroll);

    this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;

    setTimeout(() => {
      this.setTableShadow()
    }, 1500)
  },

  data () {
    return {
      isScrolled: false,
      isScrollEnd: false,
      isScroll: false,
      positionTop: 0,
      filterFieldsBlockHeight: 0,
      filteredColumn: null,
    }
  },



  methods: {
    isLatenessShow(column)
    {
      var isShow = false;
      if ("calc" in this.calcData) {
        var postCode = column.parentColumnId;
        if (!postCode) postCode=column.id
        if (postCode=="operator") postCode="Call-centr";
        isShow = postCode=="inTotal" || postCode=="total" || this.calcData.calc.delayed.posts.findIndex((p) => p.post_code==postCode ) >=0;
      }
      return isShow
    },

    isLatenessCell(columnId, isSumRow) {
      if (!isSumRow) {
        return columnId.includes('less_five') || columnId.includes('five_to_ten') || columnId.includes('more_ten')
      }
    },

    getLatenessColor(columnId, isSumRow, value) {
      let color = ''
      if (this.calcData !== null && !isSumRow && value !== '') {
        if (columnId.includes('less_five')) {
          color = this.calcData.color_settings[2].min_color
        }
        if (columnId.includes('five_to_ten')) {
          color = this.calcData.color_settings[2].middle_color
        }
        if (columnId.includes('more_ten')) {
          color = this.calcData.color_settings[2].max_color
        }
        if (columnId.includes('total') && "all_color" in this.calcData.color_settings[2]) {
          color = this.calcData.color_settings[2].all_color
        }
        if (columnId.includes('load')) {
          let code = columnId.split("_")[1];
          if (code=="operator") code="Call-centr";
          let p = this.calcData.calc.delayed.posts.find((f)=>f.post_code==code);
          if (p && p.settings) {
            let settings = p.settings;
            let kload = value;
            var max = {
              "administrator" : 13,
              "driver" : 6,
              "hot" : 3000,
              "operator" : 20,
              "pizzamaker" : 6.5,
              "suhi" : 2500,
              "noncash" : 10000,
            }
            if (kload) {
              if ("norm" in settings && settings.norm && kload>=settings.norm) {
                var c  = 212;
                if (code in max) {
                  if (kload>=max[code]) {
                    c = 0;
                  } else if (settings.norm<max[code]) {
                    c = 212 - (kload-settings.norm)/(max[code]-settings.norm) * 212;
                  }
                }
                return "rgba(255, "+c+", "+c+", 1)";
              }
              if ("norm" in settings && settings.norm && "norm2" in settings && settings.norm2 && kload>=settings.norm2) {
                var c  = 178;
                if (settings.norm>settings.norm2) {
                  c = 178 - (kload-settings.norm2)/(settings.norm-settings.norm2) * 178;
                }
                return "rgba(255, 255, "+c+", 1)";
              }
              if ("norm2" in settings && settings.norm2 && kload<settings.norm2) {
                var c1  = 225;
                var c2  = 204;
                if (settings.norm2>0) {
                  c1 = kload/(settings.norm2) * 178;
                  c2 = kload/(settings.norm2) * 204;
                }
                return "rgba("+c1+", 246, "+c2+", 1)";
              }
            }
          } else {
            console.log(p, code);
          }
          //}

          color = "red"
        }
      }


     // console.log(columnId, this.calcData);
      return color
    },

    getFirstInTotalChildColumn () {
      let c = this.data.columns.findIndex((col) => col.id.includes('inTotal') && col.id !== 'inTotal')
      if (c !== -1) return this.data.columns[c].id
      return false
    },
    isTotalValuesLateness(colId) {
      let columnGroupName = colId.split('_').pop()
      if (columnGroupName === 'inTotal') {
        return true
      }
      return false
    },

    isYellowCell(tableType, columnId, value, isTotalRow) {
      if (tableType === 'new-calculation-lateness' && !isTotalRow) {
        let columnName = columnId.split('_').slice(0, -1).join('_')
        if (columnName === 'load' && value <= 300 && value !== '') {
          return true
        }
        if (columnName === 'less_five' && (value > 5 && value < 10)) {
          return true
        }
        if (columnName === 'five_to_ten' && (value < 2 && value)) {
          return true
        }
      }
      return false
    },

    isGreenCell(tableType, columnId, value, isTotalRow) {
      if (tableType === 'new-calculation-lateness' && !isTotalRow) {
        let columnName = columnId.split('_').slice(0, -1).join('_')
        if (columnName === 'load' && (value > 300 && value < 500)) {
          return true
        }
        if (columnName === 'less_five' && (value < 5 && value)) {
          return true
        }
      }
      return false
    },

    isRedCell(tableType, columnId, value, isTotalRow) {
      if (tableType === 'new-calculation-lateness' && !isTotalRow) {
        let columnName = columnId.split('_').slice(0, -1).join('_')
        if (columnName === 'load' && value > 500 && value !== '') {
          return true
        }
        if (columnName === 'less_five' && (value > 10 && value)) {
          return true
        }
        if (columnName === 'five_to_ten' && (value > 2 && value)) {
          return true
        }
        if (columnName === 'more_ten' && (value > 1 && value)) {
          return true
        }
      }
      return false
    },

    isGreyCell(tableType, columnId, isTotalRow) {
      if (isTotalRow && tableType === 'new-calculation-lateness') {
        let columnGroupName = columnId.split('_').pop()
        let columnName = columnId.split('_').slice(0, -1).join('_')
        if (columnGroupName !== 'inTotal' && columnName !== 'less_five' && columnName !== 'five_to_ten' && columnName !== 'more_ten') {
          return true
        }

        if (columnId === 'total') {
          return true
        }
      }

      return false
    },

    handleTableScroll (e) {
      this.setTableShadow();
    },

    handleTouchMove(e) {
      // if (!e.cancelable) {
      //   e.preventDefault();
      //   return true
      // }
    },

    setTableShadow() {
      if (this.data.actions === undefined) {
        return
      }
      const ps = document.querySelector('.ps');
      const tableWrapper = document.querySelector('.c-table__wrapper');
      const tableWrapperShadow = document.querySelector('.c-table__shadow');

      if (!ps || !tableWrapperShadow) return

      let fullScrollWidth = ps.scrollWidth - ps.clientWidth;

      let diff = Math.abs(ps.scrollLeft - fullScrollWidth);

      if (diff > 3 && this.data.records.length !== 0) {
        tableWrapperShadow.classList.add('c-table__shadow_active');
      } else {
        tableWrapperShadow.classList.remove('c-table__shadow_active');
      }
    },

    resetColumnFilters () {
      this.activeFilteredColumns = [];

      this.$refs.columnFilters.resetFilters();
    },

    isColumnFiltered (columnId) {
      if (this.filteredColumns === undefined) {
        return
      }
      let result = this.filteredColumns.findIndex(i => i === columnId);

      return result !== -1;
    },

    isColumnActiveFiltered (columnId) {
      let c = this.activeFilteredColumns.findIndex(i => i.id === columnId);

      return c !== -1;
    },

    setColumnFilter (e) {
      let c = this.activeFilteredColumns.findIndex(i => i.id === e.id);

      let filterOptions = {
        id: e.id,
        type: e.type,
        searchType: e.filter.condition.value,
        value: (e.type === 'number' && e.filter.condition.value === '4') ? e.filter.rangeValue : e.filter.value
      }

      if (
        c === -1 &&
        (filterOptions.type === 'string' || filterOptions.type === 'number') &&
        filterOptions.value === ''
      ) {
        return
      }

      if (c !== -1 &&
        (filterOptions.type === 'string' || filterOptions.type === 'number')
        && filterOptions.value === ''
      ) {
        this.activeFilteredColumns.splice(c, 1)
        return
      }

      if (
        c === -1 && filterOptions.type === 'number' &&
        filterOptions.searchType === '4' &&
        (filterOptions.value.end === '' || filterOptions.value.start === '')
      ) {
        return
      }

      if (
        c !== -1 && filterOptions.type === 'number' &&
        filterOptions.searchType === '4' &&
        (filterOptions.value.end === '' || filterOptions.value.start === '')
      ) {
        this.activeFilteredColumns.splice(c, 1)
        return
      }

      if (c === -1 && filterOptions.type === 'list' && filterOptions.value.length === 0) {
        return
      }

      if (c !== -1 && filterOptions.value.length === 0) {
        this.activeFilteredColumns.splice(c, 1)
        return
      }

      if (c === -1) {
        this.activeFilteredColumns.push(filterOptions)
      } else {
        this.activeFilteredColumns.splice(c, 1)
        this.activeFilteredColumns[c] = filterOptions
      }
      return
    },

    isCategory(column) {
      return column.isCategory === 1
    },

    isSorted (column) {
      return column.isSorted
    },

    setSortedColumn (column, sortedColumn) {
      if (column.isCategory !== 1 && sortedColumn !== undefined) {
        let c = this.data.columns.findIndex(i => i.id === sortedColumn.sortBy);

        if (c !== -1) {
          this.data.columns[c].isSorted = false
        }

        column.isSorted = true
        this.sortedColumn.sortBy = column.id

        if (column.id === sortedColumn.sortBy) {
          this.sortedColumn.sortType = (this.sortedColumn.sortType === 'asc') ? 'desc' : 'asc';
        } else {
          this.sortedColumn.sortType = 'asc';
        }

        this.$emit('sortedEvent', this.sortedColumn)
      }
    },

    removeColumnFilter (columnId) {
      let c = this.activeFilteredColumns.findIndex(i => i.id === columnId);

      if (c !== -1) {
        this.activeFilteredColumns.splice(c, 1)
      }
    },

    openColumnFilterModal (column) {
      if (this.canEdit === false) {
        return;
      }
      let c = this.filteredColumns.findIndex(i => i === column.id);

      if (c !== -1) {
        this.filteredColumn = column;
      }
    },

    handleLayoutScroll () {
      const layout = document.querySelector('.layout');
      const app = document.querySelector('.app');

      let result = layout.scrollTop - this.positionTop;

      if (app.offsetWidth < 992) {
        result += 50;
      }

      if (layout.scrollTop > this.positionTop) {
        if (this.$refs.header) {
          this.$refs.header.classList.add('c-table__header-shadow')
          this.$refs.header.style.transform = `translateY(${result}px)`;
        }
      } else {
        if (this.$refs.header) {
          this.$refs.header.classList.remove('c-table__header-shadow')
          this.$refs.header.style.transform = 'none';
        }
      }
    },

    updatePositionTop (offset = 0) {
      let header = this.$refs.header.getBoundingClientRect();
      let layout = document.querySelector('.layout');
      this.positionTop = header.top + layout.scrollTop
    },

    getChildrens (columnId) {
      return this.data.columns.filter(item => {
        return item.parentColumnId === columnId;
      });
    },

    getTableColumns (level) {
      let out = [];

      let columns = this.data.columns.filter(item => {
        return item.parentColumnId === undefined;
      });

      if (level === 1) {
        out = out.concat(columns);
      } else if (level === 2) {
        for (let i in columns) {
          out = out.concat(this.getChildrens(columns[i].id))
        }
      } else if (level === 3) {
        for (let i in columns) {
          let childrens = this.getChildrens(columns[i].id)

          for (let ii in childrens) {
            out = out.concat(this.getChildrens(childrens[ii].id))
          }
        }
      }

      return out;
    },

    getColumns (level, column) {
      let cols = []

      if (level === 1) {
        cols = this.data.columns.filter(col => col.parentColumnId === undefined)
      } else if (level === 2) {
        let rootCols = this.data.columns.filter(col => col.parentColumnId === undefined)

        for (let i in rootCols) {
          let rootCol = rootCols[i]

          let childrens = this.data.columns.filter(col => col.parentColumnId === rootCol.id)

          cols = cols.concat(childrens)
        }
      } else if (level === 3) {
        let rootCols = this.data.columns.filter(col => col.parentColumnId === undefined)

        for (let i in rootCols) {
          let rootCol = rootCols[i]

          let childrens = this.data.columns.filter(col => col.parentColumnId === rootCol.id)

          for (let ii in childrens) {
            let childrens2 = this.data.columns.filter(col => col.parentColumnId === childrens[ii].id)
            cols = cols.concat(childrens2)
          }
        }
      }

      return cols
    },

    getColspan (column) {
      let children = this.data.columns.filter(col => col.parentColumnId === column.id)

      let count = children.length;

      if (column.level === 0) {
        for (let c in children) {
          let childrenChildren = this.data.columns.filter(col => col.parentColumnId === children[c].id).filter(colChild => {
            return !this.disabledColumns.includes(colChild.id)
          });

          count = count + childrenChildren.length;
        }
      }

      for (let i in children) {
        let result = this.disabledColumns.find(item => {
          return (item === children[i].id) || children[i].isCategory === 1
        })

        if (result) {
          count--;
        }
      }

      return count;
    },

    getRowspan (column) {
      let children = this.data.columns.filter(col => col.parentColumnId === column.id)

      if (this.levels === 3) {
        if (column.level === 0 && children.length === 0) {
          return 3;
        } else if (column.level === 1 && children.length === 0) {
          return 2;
        }
      } else if (this.levels === 2) {
        if (column.level === 0 && children.length === 0) {
          return 2;
        }
      }
    },

    getSeletItemLabel (record, column) {
      let cell = null;

      if (column.items) {
        let item = column.items.find(function (i) {
          return i.value === record[column.name];
        });

        cell = item ? item.label : '-';
      } else {
        cell = '-';
      }

      return cell;
    },

    scroll (e) {
      // const layout = document.querySelector('.layout');
      // // layout.classList.add('layout-touch-action-none');
      // this.isScrolled = this.$refs.wrapper.scrollLeft > 0;
      // const containerWidth = this.$refs.container.offsetWidth;
      // const wrapperWidth = this.$refs.wrapper.offsetWidth;
      // const scrollLeft = this.$refs.wrapper.scrollLeft;

      setTimeout(() => {
        this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;
      }, 300)

      this.isScrollEnd = ((this.$refs.wrapper.$el.offsetWidth + this.$refs.wrapper.$el.scrollLeft) === this.$refs.wrapper.$el.scrollWidth);
      // c-table__container__shadow-first-column

      // console.log(this.$refs.wrapper.scrollLeft)
      let table = document.getElementById('tableWithFixedFirstColumn')
      if (this.$refs.wrapper.$el.scrollLeft > 0) {
        table.classList.add('c-table__container__shadow-first-column')
      } else {
        table.classList.remove('c-table__container__shadow-first-column')
      }

      // layout.classList.remove('layout-touch-action-none');
    },

    isDisabled (id) {
      return this.disabledColumns.find(item => item === id)
    },

    getReferenceValues(e) {
      this.$emit('getReferenceValues', e)
    }
  },

  watch: {
    enabledFields (value) {
      this.updatePositionTop();
    },

    isScrollEnd (value) {
      // console.log('value: ', value)
    },

    'data.columns' (value) {
      // console.log('value: ', value)
    },

    disabledColumns (value) {
      let enabledColumns = this.data.columns.filter(item => {
        return !value.includes(item.id)
      });

      let max = Math.max.apply(null, enabledColumns.map(item => item.level))

      this.$emit('setLevelsTableData', max + 1)
      // this.levels = max + 1;

      this.setTableShadow();
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table {
  position: relative;
  display: inline-block;
  max-width: 100%;

  &__scrollbar-wrapper {
    position: fixed;
    height: 24px;
    background: white;
    box-shadow: $box-shadow;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: .2s;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  @media screen and (max-width:992px) {
    max-width: 100%;
  }

  @media screen and (max-width:700px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
    max-width: none;
  }

  &__wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    transition: .2s;
    display: inline-block;
    width: 100%;

    &::-webkit-scrollbar {
      width: 4px !important;
      height: 4px !important;
      background: white;
      cursor: pointer;
      z-index: 300;
      position: relative;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 10px;
      background-clip: padding-box;
      border: none !important;
    }

    &::-webkit-scrollbar-track {
      background: #DFE4EF;
      width: 4px !important;
      border-radius: 10px;
      z-index: 300;
      position: relative;
    }

    @media screen and (max-width:992px) {
      width: 100%;
    }
  }

  &__shadow {
    position: absolute;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
    width: 10px;
    height: calc(100% - 10px);
    right: 92px;
    opacity: 0;
    bottom: 10px;
    visibility: hidden;
    z-index: 80;
    transition: .2s;
  }

  &__empty__shadow {
    right: 0;
  }

  &__empty__records {
    border: 1px solid $color-border-alt;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    color: $label;
    font-size: 15px;
  }

  &__shadow_active {
    opacity: 0.15;
    visibility: visible;
  }

  &_scroll {
    &_shadow_right:after {
      content: '';
      position: absolute;
      right: 0;
      z-index: 100;
      pointer-events: none;
      width: 28px;
      height: 100%;
      top: 0;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    }

    .c-table__shadow {
      visibility: visible;
      opacity: .15;
    }

    .c-table__column_actions {
      &:after {
        visibility: visible !important;
        opacity: .15 !important;
      }
    }

    &.c-table_scroll_end {
      .c-table__shadow {
        visibility: hidden;
        opacity: 0;
      }

      .c-table__column_actions {
        &:after {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    }
  }

  &_scrolled {
    border-left: 1px solid $color-border-light;

    @media screen and (max-width:992px) {
      border-left: none;

      &:before {
        position: absolute;
        content: '';
        width: 22px;
        height: 100%;
        background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
        top: 0;
        left: 0;
        z-index: 100;
      }
    }
  }

  .c-table {
    &__container {
      border-collapse: collapse;
      width: 100%;

      ::v-deep .c-table__header-row:first-child th:first-child, ::v-deep td:first-child {
        position: sticky;
        background: white;
        left: 0;
        z-index: 10;
      }

      &__shadow-first-column .c-table__header-row:first-child th:first-child:after,
      &__shadow-first-column ::v-deep td:first-child:after {
        content: '';
        position: absolute;
        top: 0;
        right: -10px;
        width: 10px;
        height: 100%;
        background: linear-gradient(90deg, #001550 0%, rgba(255, 255, 255, 0) 100%);
        opacity: 0.15;
      }

      ::v-deep .c-table__header-row:first-child th:first-child:before,
      ::v-deep td:first-child:before{
        content: '';
        position: absolute;
        top: -1px;
        bottom: -1px;
        left: -1px;
        right: -1px;
        border: 1px solid #dfe4ef;
        pointer-events: none;
      }
    }

    &__header {
      border-bottom: 2px solid $color-border-light;
      position: relative;
      background: $color-border-light;
      z-index: 70;
    }

    &__header-shadow:after {
      content: '';
      position: absolute;
      background: linear-gradient(#001550, rgba(255, 255, 255, 0));
      width: 100%;
      height: 10px;
      opacity: 0.15;
      z-index: 69;
      bottom: -10px;
      left: 0;
    }

    &__column {
      text-align: left;
      border: 1px solid $color-border-light;
      vertical-align: top;
      height: 1px;
      padding: 0;
      transition: .2s;

      &_hidden {
        width: 0;
        border: none;
        overflow: hidden;
        display: none;
        // margin-left: -1px;

        .c-table__column-wrapper {
          width: 0;
          padding: 0;
          border: none;
        }
      }

      &_with {
        &_filter {
          .c-table__column {
            &-wrapper {
              flex-direction: column;
            }

            &-actions {
              margin-top: 10px;
            }
          }
        }
      }

      &_sorted {
        .c-table__column-label {
          color: $color-primary;
        }
      }

      &-label {
        color: $color-label;
        font: {
          size: 12px;
          weight: 500;
        }
        line-height: 100%;

        &-children {
          cursor: pointer;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        height: 100%;
        background: white;
      }

      &-actions {
        display: flex;
        justify-content: space-between;
      }

      &-action {
        width: 14px;
        height: 14px;

        .c-button {
          width: 14px;
          height: 14px;
        }

        &_description {
          margin-left: -3px;
        }
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 30;

        &:after {
          content: '';
          position: absolute;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
          width: 10px;
          height: 100%;
          left: -11px;
          opacity: 0;
          bottom: 0;
          visibility: hidden;
          z-index: 40;
        }
      }

      &-empty {
        background: white;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        border-bottom: 2px solid $color-border-light;
        margin-left: -1px;
        position: relative;
      }

      &_border_left {
        border-left-style: ridge !important;
        border-left: solid 2px #DFE4EF;
      }
    }

    &__cell {
      border: 1px solid $color-border-light;
      padding: 0;
      height: 1px;
      transition: .2s;

      &__yellow {
        background: rgb(253, 255, 179);
      }

      &__red {
        background: rgb(255, 211, 232);
      }

      &__green {
        background: rgb(208, 244, 227)
      }

      &__grey {
        background: #F5F7FA !important;
      }

      &_border_left {
        border-left-style: solid !important;
        border-left: solid 2px #DFE4EF;
      }

      &_number {
        & .c-table__cell-value {
          text-align: right;
        }
      }

      &_rank {
        & .c-table__cell-value {
          text-align: left;
        }
      }

      &_hidden {
        width: 0;
        overflow: hidden;
        border: none;
        display: none;

        .c-table__cell-value,
        .c-table__cell-cell {
          width: 0;
          padding: 0;
        }
      }

      &-cell {
        transition: .2s;
      }

      &-value {
        line-height: 13px;
        font-size: 13px;
        padding: 10px;
        transition: .2s;

        &__grey {
          color: #8E9CBB;
        }
      }

      &-pre-formatted {
        white-space: pre;
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 20;
      }

      &-actions {
        background: white;
        width: calc(100% + 1px);
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        margin-left: -1px;
      }
    }
  }
}

::v-deep .ps__rail-x {
  z-index: 351;
  background: #ffffff !important;
}

::v-deep .ps__rail-x:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30px, 0);
  box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
  z-index: -1;
  height: 24px;
  width: calc(100vw - 60px);
  background: #ffffff;
}

::v-deep .ps__rail-x:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, calc(-50% + 1px));
  border-radius: 10px;
  z-index: -1;
  height: 4px;
  width: calc(100% - 34px);
  background: #DFE4EF;
}
</style>